import { render, staticRenderFns } from "./ReceivedDeliveries.vue?vue&type=template&id=d1f7d5fe"
import script from "./ReceivedDeliveries.vue?vue&type=script&lang=js"
export * from "./ReceivedDeliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports